import useApi from '../utils/axios-pettitions';
import { CustomFilters } from '../types/types.system';

export const useApiReports = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const getReportsAndWorkList = async (filters: CustomFilters[]) => {
    return runApi('ReportsList/GetReportsAndWorkList', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const GetInformedConsentsList = async () => {
    return runApi('ReportsList/GetInformedConsentsList', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  //Obtener configuración
  const getControlsBoards = async (filters: CustomFilters[]) => {
    return runApi('ReportsList/GetControlsBoards', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  //Obtener configuración
  const runBoardReport = async (filters: any[], query: string) => {
    return runApi('ReportsList/RunBoardReport', 'POST', { query }, filters).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const createControlsBoard = async (data: any) => {
    return runApi('ReportsList/CreateControlsBoard', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else {
        return true;
      }
    });
  };

    const updateControlsBoard = async (data: any, idReport: number) => {      
    return runApi('ReportsList/UpdateControlsBoard', 'POST', {idReport}, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else {
        return true;
      }
    });
  };

  return { getReportsAndWorkList, getControlsBoards, runBoardReport, GetInformedConsentsList, createControlsBoard, updateControlsBoard };
};
